import { Outlet } from "react-router-dom";
import Footer from "./footer";
import TopNav from "./top-nav";

function HomeLayout() {
  return (
    <div className="w-full h-screen bg-white overflow-y-auto style-scroll">
      <TopNav />
      <div className="min-h-screen flex flex-col pt-20 ">
        <div className="flex-grow">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default HomeLayout;
